import React from 'react';
import { Mail, Phone, Globe, MapPin } from 'lucide-react';
export function EmailSignature() {
  return <div className="max-w-3xl mx-auto p-8" data-id="element-39">
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8" data-id="element-40">
        <table cellPadding="0" cellSpacing="0" border={0} style={{
        fontFamily: 'system-ui, -apple-system, sans-serif',
        fontSize: '15px',
        lineHeight: '1.4',
        borderCollapse: 'collapse'
      }} data-id="element-41">
          <tbody data-id="element-42">
            <tr data-id="element-43">
              <td style={{
              paddingRight: '32px',
              verticalAlign: 'middle',
              borderRight: '2px solid #1e293b',
              width: '140px'
            }} data-id="element-44">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wxtonoDTZefwd495z2JgnJ/LOGO_ET_SLOGAN_%281%29.jpg" alt="IPcom Logo" style={{
                width: '140px',
                height: 'auto',
                display: 'block'
              }} data-id="element-45" />
              </td>
              <td style={{
              paddingLeft: '32px',
              verticalAlign: 'middle'
            }} data-id="element-46">
                <table cellPadding="0" cellSpacing="0" border={0} style={{
                borderCollapse: 'collapse'
              }} data-id="element-47">
                  <tbody data-id="element-48">
                    <tr data-id="element-49">
                      <td style={{
                      paddingBottom: '10px'
                    }} data-id="element-50">
                        <div style={{
                        fontSize: '20px',
                        fontWeight: '600',
                        color: '#0f172a',
                        marginBottom: '2px',
                        letterSpacing: '-0.01em',
                        lineHeight: '1.2'
                      }} data-id="element-51">
                          Mehdi FATHALLAH
                        </div>
                        <div style={{
                        fontSize: '15px',
                        color: '#475569',
                        fontWeight: '500',
                        lineHeight: '1.3'
                      }} data-id="element-52">
                          Agent IT, IPcom
                        </div>
                      </td>
                    </tr>
                    <tr data-id="element-53">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-54">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-55">
                          Mobile :{' '}
                        </span>
                        <span style={{
                        color: '#1e293b',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-56">
                          +33 (0) 7 53 29 34 19
                        </span>
                      </td>
                    </tr>
                    <tr data-id="element-57">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-58">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-59">
                          Tél :{' '}
                        </span>
                        <span style={{
                        color: '#1e293b',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-60">
                          +33 (1) 47 90 08 19
                        </span>
                      </td>
                    </tr>
                    <tr data-id="element-61">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-62">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-63">
                          Email :{' '}
                        </span>
                        <a href="mailto:m.fathallah@ipcom-fr.com" style={{
                        color: '#1e293b',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-64">
                          m.fathallah@ipcom-fr.com
                        </a>
                      </td>
                    </tr>
                    <tr data-id="element-65">
                      <td style={{
                      paddingTop: '2px',
                      paddingBottom: '2px'
                    }} data-id="element-66">
                        <span style={{
                        color: '#64748b',
                        fontSize: '14px',
                        fontWeight: '500'
                      }} data-id="element-67">
                          Web :{' '}
                        </span>
                        <a href="https://www.ipcom-fr.com" style={{
                        color: '#1e293b',
                        textDecoration: 'none',
                        fontSize: '14px',
                        fontWeight: '400'
                      }} data-id="element-68">
                          ipcom-fr.com
                        </a>
                      </td>
                    </tr>
                    <tr data-id="element-69">
                      <td style={{
                      paddingTop: '8px'
                    }} data-id="element-70">
                        <div style={{
                        fontSize: '13px',
                        color: '#64748b',
                        lineHeight: '1.4',
                        fontWeight: '400'
                      }} data-id="element-71">
                          17, Avenue des Louvresses, bât B2
                          <br data-id="element-72" />
                          92230 Gennevilliers, France
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div className="mt-8 p-4 bg-gray-50 rounded-lg border border-gray-200" data-id="element-73">
        <h3 className="font-semibold text-gray-900 mb-2 text-sm" data-id="element-74">
          Instructions d'installation
        </h3>
        <ol className="text-xs text-gray-600 space-y-1.5 ml-4 list-decimal" data-id="element-75">
          <li data-id="element-76">
            Copiez le code HTML de la signature depuis les paramètres de votre
            client email
          </li>
          <li data-id="element-77">
            Outlook : Paramètres → Courrier → Rédaction et réponse → Signature
            email
          </li>
          <li data-id="element-78">
            Gmail : Paramètres → Général → Signature → Créer une nouvelle
            signature
          </li>
        </ol>
      </div>
    </div>;
}